import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-result-found',
  templateUrl: './no-result-found.component.html',
  styleUrls: ['./no-result-found.component.scss']
})
export class NoResultFoundComponent implements OnInit {
  categoryHeaderId: string;
  requestProductView = {}
  constructor() { }

  ngOnInit(): void {
  }
  onCategoryFilterChange(categoryId: string) {
    this.categoryHeaderId = categoryId;
    this.requestProductView['categoryCode'] = categoryId
  }
  onBrandFilterChange(Brand: string) {
  }




  // Event handler for open filter change
  onOpenFilterChange(openFilterValue: string) {
  }
  onSearchFilterChange(searchFilterChange: string) {
  }
  oncontentSearchFilterChange(searchFilterChange: string) {
  }
}
